import PropTypes from 'prop-types';
import { FormLabel } from "@mui/material";
import { font } from "../../Tokens";

function AppLabel({ children, required, disabled, Icon, sx, ...rest }) {

    return (
        <FormLabel
            required={required}
            disabled={disabled}
            sx={{
                ...font.label,
                ...(Icon && { display: 'flex', alignItems: 'center', gap: 0.5 }),
                // MUI only colors the asterisk red when the label is also in an
                // error state; force it red whenever required so the marker
                // reads consistently as "required" rather than "invalid".
                ...(required && { '& .MuiFormLabel-asterisk': { color: 'error.main' } }),
                ...sx,
            }}
            {...rest}
        >
            {Icon && <Icon sx={{ fontSize: 15, color: disabled ? 'action.disabled' : 'text.secondary' }} />}
            {children}
        </FormLabel>
    );

}

AppLabel.propTypes = {
  children: PropTypes.node,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  Icon: PropTypes.elementType,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AppLabel;